{
  "name": "neo-clinic",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "npm run changelog",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "changelog": "git-cliff --output src/assets/CHANGELOG.md"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.10",
    "@angular/cdk": "^21.2.8",
    "@angular/common": "^21.2.10",
    "@angular/compiler": "^21.2.10",
    "@angular/core": "^21.2.10",
    "@angular/forms": "^21.2.10",
    "@angular/material": "^21.2.8",
    "@angular/platform-browser": "^21.2.10",
    "@angular/router": "^21.2.10",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^14.0.0",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.8",
    "@angular/cli": "^21.2.13",
    "@angular/compiler-cli": "^21.2.10",
    "@types/jasmine": "~6.0.0",
    "jasmine-core": "~6.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "typescript": "~5.9.2"
  }
}
